export const key = 'rusted_labs_recaptcha_callback';
export const queueKey = 'rusted_labs_recaptcha_callbacks';
